/** Localized text for a classified failure; the English text in the contracts layer is only a fallback for logs and tests. */
import {classifyFailure,type Failure} from '@miraops/contracts';
import type {MessageKey} from './i18n.tsx';
export function failureText(t:(key:MessageKey)=>string,failure:Pick<Failure,'kind'>):string{return t(`failure.${failure.kind}` as MessageKey);}
/** Opening a record by its address failed: `true` when it is gone or not allowed (the caller says
 *  "doesn't exist or you can't open it"); otherwise the reason, such as being offline, so a
 *  connection problem is never reported as a missing record. */
export function openFailure(t:(key:MessageKey)=>string,error:unknown):true|string{
 const failure=classifyFailure({error,operation:'read'});
 return failure.kind==='not_found'||failure.kind==='access_revoked'?true:failureText(t,failure);
}
/** A Supabase Auth error that means Auth wasn't reached (no answer) or was busy (5xx), so the
 *  two-factor screens never call it a wrong code; null for an answer about the request itself. */
export function authUnreachable(error:{name?:string;status?:number}|null|undefined):'network'|'service_unavailable'|null{
 if(!error)return null;
 if(typeof error.status==='number'&&error.status>=500)return 'service_unavailable';
 return error.name==='AuthRetryableFetchError'||!error.status?'network':null;
}
